import { useEffect, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { getHebrewYear } from '../../../../../utils/hebrew-date-utils';
import { Dropdown } from 'primereact/dropdown';
import { updateWorkingYearsOperation } from './operations/update-working-years-operation';
import { Button } from 'primereact/button';
import globalSettingsBranches from '../../../../../stores/global-settings-branches';
import { observer } from 'mobx-react-lite';
import { Dialog } from 'primereact/dialog';
import { toast } from 'react-toastify';

export interface WorkingYearsManagementDataModel {
  year: number;
  code: string;
  value: number;
}

export const WorkingYearsManagement = observer(() => {
  const years = [];
  for (let year = 1980; year <= 2030; year++) {
    years.push({
      year: `${getHebrewYear(year)} (${year} - ${year + 1})`,
      code: 'year',
      value: year,
    });
  }

  const [availableWorkingYears, setAvailableWorkingYears] = useState<
    number[] | null
  >(null);

  const [workingYear, setWorkingYear] = useState<number | null>(null);

  useEffect(() => {
    const asd = globalSettingsBranches.workingTimeManagement;
    if (asd) {
      setAvailableWorkingYears(asd.availableWorkingYears);
      setWorkingYear(asd.currentWorkingYear);
    }
  }, [globalSettingsBranches.workingTimeManagement]);

  const handleUpdateWorkingYears = async () => {
    await updateWorkingYearsOperation(
      globalSettingsBranches.workingTimeManagement?.currentWorkingYear ??
        undefined,
      workingYear,
      availableWorkingYears,
    );
  };

  const [displayDialog, setDisplayDialog] = useState(true);

  return (
    <div>
      <Dialog
        header="ניהול שנות עבודה במערכת"
        visible={displayDialog}
        style={{
          width: '500px',
          height: '100vh',
          minHeight: '100vh',
          borderRadius: '0 8px 8px 0', // Only right-side border radius (top-right, bottom-right)

          backgroundColor: 'white',
          padding: '8px',
          position: 'absolute',
          left: '0px', // Positions it from the left edge
          top: '0', // Aligns to the top of the viewport
          margin: '0', // Removes any margin
          transform: 'none', // Removes any transform that might affect positioning
          display: 'flex', // Using flex for better content organization
          flexDirection: 'column', // Stacks header and content vertically
        }}
        onHide={() => {
          setDisplayDialog(false);
        }}
      >
        <label>שנות עבודה זמינות במערכת</label>
        <MultiSelect
          value={availableWorkingYears}
          options={years}
          style={{ width: '100%', marginBottom: '16px' }}
          filter
          filterPlaceholder="חפש שנה..."
          onChange={(e) => setAvailableWorkingYears(e.value)}
          optionLabel="year"
          placeholder="בחר שנה"
          className="w-full md:w-20rem"
        />

        <label>שנת עבודה נוכחית</label>

        <Dropdown
          value={workingYear}
          options={years}
          style={{ width: '100%', marginBottom: '16px' }}
          onChange={(e) => setWorkingYear(e.value)}
          optionLabel="year"
          placeholder="בחר שנת עבודה נוכחית"
          dir="rtl" // Add this line for RTL support
          panelStyle={{ maxWidth: '200px' }}
        />

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            style={{ height: '30px' }}
            label={'אישור'}
            onClick={handleUpdateWorkingYears}
          />
        </div>
      </Dialog>
    </div>
  );
});
